/**
 * 路由存储格式
 * {
 *    routerId:路由ID
 *    from:当前页面ID,
 *    next:下一个页面ID,
 *    meta:{
 *        keep：alive 为缓存保留DOM，memory 为存储内存中且消除DOM, false 代表不缓存 
 *        enterAnim:进入动画,
 *        quitAnim:退出动画,
 *        params:传递的参数对象,
 *    },
 *    pageSettingData:当前页面整个配置对象,
 *    domCache:当前整个页面的DOM对象
 * }
 */
var routerList = [];
//vue的router对象
var vueRouter=null;
//加载其他lib的状态
var initOtherLibState={
    react:false
};
/**
 * 标志是否内部路由触发的事件
 */
var idmInnerRouterEvent=false;
/**
 * 用于存储返回过的历史记录
 */
var backHistroyRouterList = [];
/**
 * 页面加载的缓存池
 */
var pageDataCachePool = null;
/**
 * 页面跳转
 * @param {String} from 当前页面ID
 * @param {String} next 下一个页面ID
 * @param {String or Object or Boolean} keep 》 alive 为缓存保留DOM，memory 为存储内存中且消除DOM，或者为对象格式{keep,params,enterAnim,quitAnim}
 * @param {Object} params 传递的参数对象
 * @param {String} enterAnim 进入动画
 * @param {String} quitAnim 退出动画
 * @returns 
 */
function push(from,next,keep,params,enterAnim,quitAnim){
    var meta = {keep,params,enterAnim,quitAnim};
    IDM.type(keep)=='object'?meta=keep:null;
    var routerId = IDM.uuid();
    //追加到路由存储中
    var rObject = {
        routerId,from,next,meta
    };
    //根据当前页面ID from 去查找等于pageid的页面挂起事件或者卸载事件，如果返回false则不进行卸载
    var pageSetData = IDM.router.pageDataCachePool.get(from);
    if(pageSetData){
        var propData=null;
        for (
            var index = 0;
            index < pageSetData.page.componentsMap.length;
            index++
          ) {
            const item = pageSetData.page.componentsMap[index];
            if (item.packageid == pageSetData.page.layout.packageid) {
                propData = item.props.compositeAttr;
                break;
            }
          }
        if(propData&&meta.keep){
            //缓存，执行挂起事件
            this.commonCustomEventFunHandle(propData,"pageSuspendFunction",rObject,from);
            //发送挂起的消息
            window.IDM.broadcast&&window.IDM.broadcast.send({
                type:"pageSuspend"
            },routerList&&routerList.length?routerList[routerList.length-1].routerId||"":"");
        }else if(propData){
            //卸载事件，如果返回false则直接return
            let pageNoKeepBeforeDestroy = this.commonCustomEventFunHandle(propData,"pageNoKeepBeforeDestroyFunction",rObject,from);
            if(pageNoKeepBeforeDestroy===false){
                return;
            }
            //发送卸载的消息
            window.IDM.broadcast&&window.IDM.broadcast.send({
                type:"pageDestroy",
                message:"noKeep"
            },routerList&&routerList.length?routerList[routerList.length-1].routerId||"":"");
        }
    }
    routerList.push(rObject);
    if(IDM.type(keep)=='object'&&params===false){
        //这个代表是通过浏览器进行前进的
        this.idmInnerRouterEvent = false;
    }else{
        this.idmInnerRouterEvent = true;
        //拿当前整个路由对象调用加载下一个页面
        this.vueRouter.push({ name: 'Preview', params: { pageid: routerList[0].from,inPageid:rObject.next } })
    }
    //调用preview方法
    window.IdmBuiltin_InitNewPage(rObject);
    return routerId;
}
/**
 * 返回（关闭）页面
 * @param {String} routerId 要返回的路由ID
 * @param {Object} params 返回传递的参数对象
 */
function back(routerId,params){
    //根据routerId查找路由数据
    var router=null,prevRoter=null;
    for (let index = 0; index < this.routerList.length; index++) {
        const item = this.routerList[index];
        if(item.routerId==routerId){
            router = _.cloneDeep(item);
            //触发卸载前事件，返回false则不返回
            var pageSetData = IDM.router.pageDataCachePool.get(router.next);
            if(pageSetData){
                var propData=null;
                for (
                    var index1 = 0;
                    index1 < pageSetData.page.componentsMap.length;
                    index1++
                ) {
                    const item1 = pageSetData.page.componentsMap[index1];
                    if (item1.packageid == pageSetData.page.layout.packageid) {
                        propData = item1.props.compositeAttr;
                        break;
                    }
                }
                if(propData){
                    //卸载事件，如果返回false则直接return
                    let pageBackBeforeDestroy = this.commonCustomEventFunHandle(propData,"pageBackBeforeDestroyFunction",router,router.next,params);
                    if(pageBackBeforeDestroy===false){
                        return;
                    }
                    //发送卸载的消息
                    window.IDM.broadcast&&window.IDM.broadcast.send({
                        type:"pageDestroy",
                        message:"back"
                    },routerId||"");
                }
            }
            this.backHistroyRouterList.push(router);
            this.routerList.splice(index,1);
            break;
        }
        prevRoter = _.cloneDeep(item);
    }
    if(router!=null){
        this.idmInnerRouterEvent = params!==false;
        //判断上一页是否缓存来进行重新加载之类的操作
        params!==false&&this.vueRouter.back();
        //调用preview方法
        window.IdmBuiltin_backPage(router,prevRoter);
    }
    return router;
}
/**
 * 通用自定义函数
 * @param {*} propData 
 * @param {*} name 
 * @param {*} router 
 * @param {*} pageid 
 * @returns 
 */
function commonCustomEventFunHandle(propData,name,router,pageid,params){
    var customHandle = propData[name],resultData;
    customHandle &&
    customHandle.forEach((item) => {
        resultData = window[item.name] &&
        window[item.name].call(this, {
            urlData:IDM.url.queryObject(),
            customParam: item.param,
            router,
            pageid,
            params
        });
    });
    return resultData
}
/**
 * 路由外部改变了要触发IDM内部的路由改变事件
 * @param {*} to 即将要进入的目标 路由对象
 * @param {*} from 当前导航正要离开的路由
 */
function innerRouterChangeEvent(to,from){
    //最后一条前进的数据
    var lastRouterObject = this.routerList.length>0? this.routerList[this.routerList.length-1]:null;
    //最后一条后退的数据
    var lastBackRouterObject = this.backHistroyRouterList.length>0?this.backHistroyRouterList[this.backHistroyRouterList.length-1]:null;
    //拿to去与routerList的最后一条对比，to对比routerList的from，from对比routerList的next，符合则是返回，不符合则是前进
    if(lastRouterObject&&(lastRouterObject.from==to.params.inPageid||to.params.inPageid===undefined)&&lastRouterObject.next==from.params.inPageid){
        //执行返回操作
        IDM.router.back(lastRouterObject.routerId,false)
    }else if(lastBackRouterObject&&lastBackRouterObject.next==to.params.inPageid&&(from.params.inPageid===undefined||from.params.inPageid==lastBackRouterObject.from)){
        //执行前进操作
        IDM.router.push(lastBackRouterObject.from,lastBackRouterObject.next,{
            keep:lastBackRouterObject.keep,
            params:lastBackRouterObject.params,
            enterAnim:lastBackRouterObject.enterAnim,
            quitAnim:lastBackRouterObject.quitAnim
        },false)
        //需要执行删除
        this.backHistroyRouterList.splice(this.backHistroyRouterList.length-1,1);
    }
}
/**
 * 根据路由ID设置当前路由页面的配置数据
 * @param {String} routerId 要设置的路由ID
 * @param {Object} pageData 要设置的页面数据
 */
function setPageData(routerId,pageData){
    //根据routerId设置数据

}
/**
 * 把DOM设置到缓存中，同时会清空DOM
 * @param {String} routerId 要设置DOM到缓存中的路由ID
 */
function setDomToCache(routerId){
    //根据routerId设置数据
    var _domCache = document.querySelector("#router_page_"+routerId);
    for (let index = 0; index < this.routerList.length; index++) {
        const item = this.routerList[index];
        if(item.routerId==routerId){
            item.domCache = _domCache;
            break;
        }
    }
}
/**
 * 根据路由ID获取当前传过来的参数
 * @param {String} routerId 要获取参数的路由ID
 */
function getParam(routerId){
    //根据routerId查找路由数据，并且返回参数
    for (let index = 0; index < this.routerList.length; index++) {
        const item = this.routerList[index];
        if(item.routerId==routerId){
            return item.meta.params;
        }
    }
}
/**
 * 根据路由ID获取路由对象
 * @param {String} routerId 路由ID
 */
function getRouter(routerId){
    for (let index = 0; index < this.routerList.length; index++) {
        const item = this.routerList[index];
        if(item.routerId==routerId){
            return item;
        }
    }
}
/**
 * 设置vue router对象
 * @param {Object} router 设置的对象
 */
function setVueRouter(router){
    this.vueRouter = router;
}
/**
 * 设置已经加载react的lib
 */
function setReact(){
    this.initOtherLibState.react = true;
}
/**
 * 获取已经加载react的lib
 */
function getReact(){
    return this.initOtherLibState.react;
}
export default {
    routerList,
    push,
    back,
    setDomToCache,
    setPageData,
    getParam,
    getRouter,
    setVueRouter,
    setReact,
    getReact,
    vueRouter,
    initOtherLibState,
    idmInnerRouterEvent,
    innerRouterChangeEvent,
    backHistroyRouterList,
    pageDataCachePool,
    commonCustomEventFunHandle
}